import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
// Las variables de la casa (generadas desde frontend/src/diseno/tokens.ts) y, encima, las del acceso.
import './styles/casa.css';
import './styles/tokens.css';
import './styles/brand.css';
import i18n from './i18n';

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

